import { render } from "./Widget2.vue?vue&type=template&id=4eabc4ea&ts=true"
import script from "./Widget2.vue?vue&type=script&lang=ts"
export * from "./Widget2.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__